import React, { useState } from 'react';
import RoleAllow from './RoleAllow/RoleAllow';
import AddAmenity from '../AddAmenity/AddAmenity';
import AddAmenityType from '../AddAmenityType/AddAmenityType';
import AddSlot from '../AddSlot/AddSlot';
import AddServices from '../AddServices/AddService';
import Loading from "../../component/Loading/Loading";
import AddViolation from '../AddViolation/AddViolation';

const Settings = () => {
    const [activeTab, setActiveTab] = useState(1);
    const [selectedBtns, setSelectedBtns] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    const handleButtonClick = (btnName) => {
        if (selectedBtns.includes(btnName)) {
            setSelectedBtns(selectedBtns.filter((btn) => btn !== btnName));
        } else {
            setSelectedBtns([...selectedBtns, btnName]);
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Settings</h1>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="overflow-x-auto">
                            <div className="flex flex-nowrap overflow-x-auto">
                                <div
                                    className={`font-medium py-3 px-6 text-center cursor-pointer select-none whitespace-nowrap ${activeTab === 1 ? 'text-white bg-blue-500 border-b-2 border-blue-600' : 'text-gray-700 hover:bg-gray-50 border-b border-gray-300'}`}
                                    onClick={() => handleTabClick(1)}
                                >
                                    Amenity Type
                                </div>
                                <div
                                    className={`font-medium py-3 px-6 text-center cursor-pointer select-none whitespace-nowrap ${activeTab === 2 ? 'text-white bg-blue-500 border-b-2 border-blue-600' : 'text-gray-700 hover:bg-gray-50 border-b border-gray-300'}`}
                                    onClick={() => handleTabClick(2)}
                                >
                                    Amenity
                                </div>
                                <div
                                    className={`font-medium py-3 px-6 text-center cursor-pointer select-none whitespace-nowrap ${activeTab === 3 ? 'text-white bg-blue-500 border-b-2 border-blue-600' : 'text-gray-700 hover:bg-gray-50 border-b border-gray-300'}`}
                                    onClick={() => handleTabClick(3)}
                                >
                                    Amenity Slot
                                </div>
                                <div
                                    className={`font-medium py-3 px-6 text-center cursor-pointer select-none whitespace-nowrap ${activeTab === 4 ? 'text-white bg-blue-500 border-b-2 border-blue-600' : 'text-gray-700 hover:bg-gray-50 border-b border-gray-300'}`}
                                    onClick={() => handleTabClick(4)}
                                >
                                    Service Type
                                </div>
                                <div
                                    className={`font-medium py-3 px-6 text-center cursor-pointer select-none whitespace-nowrap ${activeTab === 5 ? 'text-white bg-blue-500 border-b-2 border-blue-600' : 'text-gray-700 hover:bg-gray-50 border-b border-gray-300'}`}
                                    onClick={() => handleTabClick(5)}
                                >
                                    Violation Type
                                </div>
                                {/* <div
                                    className={`font-medium py-3 px-6 text-center cursor-pointer select-none whitespace-nowrap ${activeTab === 6 ? 'text-white bg-blue-500 border-b-2 border-blue-600' : 'text-gray-700 hover:bg-gray-50 border-b border-gray-300'}`}
                                    onClick={() => handleTabClick(6)}
                                >
                                    Role Permission
                                </div> */}
                            </div>

                            <div className="mt-4 ">
                                {activeTab === 1 && (
                                    <div className="">
                                        <AddAmenityType />
                                    </div>
                                )}

                                {activeTab === 2 && (
                                    <div className="">
                                        <AddAmenity />
                                    </div>
                                )}

                                {activeTab === 3 && (
                                    <div className="">
                                        <AddSlot />
                                    </div>
                                )}

                                {activeTab === 4 && (
                                    <div className="">
                                        <AddServices />
                                    </div>
                                )}

                                {activeTab === 5 && (
                                    <div className="">
                                        <AddViolation />
                                    </div>
                                )}
{/* 
                                {activeTab === 6 && (
                                    <div className="">
                                        <RoleAllow />
                                    </div>
                                )} */}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Settings;